import { MenuItemProps } from '../../StylableHorizontalMenu.types';

const hasSubItems = (item: MenuItemProps) => item.items?.length;

export const forceOpenMenu = (items: Array<MenuItemProps>) => {
  const itemWithSubItemsIndex = items.findIndex(hasSubItems);

  if (itemWithSubItemsIndex === -1) {
    return items;
  }

  const itemWithSubSubItemsIndex = items.findIndex(item =>
    item.items?.some(hasSubItems),
  );

  if (itemWithSubSubItemsIndex === -1) {
    return items.map((item, index) =>
      index === itemWithSubItemsIndex ? { ...item, forceHovered: true } : item,
    );
  }

  const subItemIndex = items[itemWithSubSubItemsIndex].items!.findIndex(
    hasSubItems,
  );

  return items.map((item, index) =>
    index === itemWithSubSubItemsIndex
      ? {
          ...item,
          forceHovered: true,
          items: item.items?.map((subItem, sIndex) =>
            sIndex === subItemIndex
              ? { ...subItem, forceHovered: true }
              : subItem,
          ),
        }
      : item,
  );
};
